export enum ComparisonOperator {
  Gt = 'gt', // greater than
  Lt = 'lt', // less than
  Ge = 'ge', // greater or equal
  Le = 'le', // less or equal
  Eq = 'eq', // equal
  Ne = 'ne', // not equal
  In = 'in' // value is in array
}

export enum BooleanOperator {
  And = 'and',
  Or = 'or',
  Not = 'not'
}
